import { NumberOrNullOrUndefined, StringOrNullOrUndefined } from 'src/app/shared/utils';

export class ProviderCptCode {
    code: string = '';
    units: number = 0;
    average_units: number = 0;
    remaining_units: number = 0;
    end_date: string = '';

    constructor(data: Partial<ProviderCptCode> = {}) {
        this.code = StringOrNullOrUndefined(data.code) ?? '';
        this.units = NumberOrNullOrUndefined(data.units) ?? 0;
        this.average_units = NumberOrNullOrUndefined(data.average_units) ?? 0;
        this.remaining_units = NumberOrNullOrUndefined(data.remaining_units) ?? 0;
        this.end_date = StringOrNullOrUndefined(data.end_date) ?? '';
    }
}

export class WorkedHour {
    id: number = 0;
    name: string = '';
    client_id: number = 0;
    client_name: string = '';
    cpt_codes: ProviderCptCode[] = [];

    constructor(data: Partial<WorkedHour> = {}) {
        this.id = NumberOrNullOrUndefined(data.id) ?? 0;
        this.name = StringOrNullOrUndefined(data.name) ?? '';
        this.client_id = NumberOrNullOrUndefined(data.client_id) ?? 0;
        this.client_name = StringOrNullOrUndefined(data.client_name) ?? '';
        this.cpt_codes = (data.cpt_codes ?? []).map(cpt => new ProviderCptCode(cpt));
    }
}

export class WorkedHoursProvider {
    id: number = 0;
    name: string = '';
    client_id: number = 0;
    client_name: string = '';
    cpt_codes: ProviderCptCode[] = [];

    constructor(data: Partial<WorkedHoursProvider> = {}) {
        this.id = NumberOrNullOrUndefined(data.id) ?? 0;
        this.name = StringOrNullOrUndefined(data.name) ?? '';
        this.client_id = NumberOrNullOrUndefined(data.client_id) ?? 0;
        this.client_name = StringOrNullOrUndefined(data.client_name) ?? '';
        this.cpt_codes = (data.cpt_codes ?? []).map(cpt => new ProviderCptCode(cpt));
    }
}
